module.exports = __webpack_public_path__ + "static/expertPreview1-09f2119ff3741d61ea496a47c5c2f216.png";